export const BILLING_INTERVALS = [
  { value: 'week', label: 'Weekly' },
  { value: 'month', label: 'Monthly' },
  { value: 'quarter', label: 'Quarterly' },
  { value: 'half_year', label: 'Half-yearly' },
  { value: 'year', label: 'Annual' }
];

export const CUSTOM_INTERVAL = 'custom';

export const CURRENCY_OPTIONS = ['USD'];
